// extracted by mini-css-extract-plugin
export default {"mainMenu":"MPDLAjFc4UClnkv_VYUe","mainMenuItem":"lVKYtNvnMB_ubBMh6Ksc","active":"k_eZ427FH38PORBYuAgA"};